import { useTranslation } from 'react-i18next';

const FamilyBuildingSurrogacyAgency = ({ prevStep, handleChange, formData, nextStep,error,step, totalSteps, isHighmarkPortal }) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="step-section">
        <div className="surrogacy-journey-label">Surrogacy Journey</div>
        <h3 className="page-heading-secondary-black-500 mb-5">Do you currently have a surrogacy agency?</h3>
        
        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            name="SurrogacyAgency"
            id="surrogacyAgency1"
            value="Yes"
            checked={formData.SurrogacyAgency === "Yes"}
            onChange={handleChange}
          />
          <label htmlFor="surrogacyAgency1" className="multistep-form-radio-checkbox-label">Yes</label>
        </div>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            name="SurrogacyAgency"
            id="surrogacyAgency2"
            value="No"
            checked={formData.SurrogacyAgency === "No"}
            onChange={handleChange}
          />
          <label htmlFor="surrogacyAgency2" className="multistep-form-radio-checkbox-label">No</label>
        </div>

        <div className="mb-3 form-check multi-step-form-rdb-chekcbox-wrapper">
          <input
            type="radio"
            className="form-check-input radio-btn win-form-check-input"
            name="SurrogacyAgency"
            id="surrogacyAgency3"
            value="Not sure / exploring"
            checked={formData.SurrogacyAgency === "Not sure / exploring"}
            onChange={handleChange}
          />
          <label htmlFor="surrogacyAgency3" className="multistep-form-radio-checkbox-label">Not sure / exploring</label>
        </div>
        {error && <p className="text-danger">{error}</p>}
        {/* Navigation Buttons */}
        <div className="mt-5">
    {isHighmarkPortal ? (
    <div className="pagination-wrapper mt-5">
      <button className="previous-btn" onClick={prevStep}></button>
      <span className="me-3">{step} of {totalSteps}</span>
      <button className="next-btn" onClick={nextStep}></button>
    </div>
  ) : (
    <>
      <button className="win-btn-secondary mobile-view me-3 mb-2 mb-md-0" onClick={prevStep}>
        {t('back')}
      </button>
      <button className="win-btn-primary mobile-view mb-3" onClick={nextStep}>{t('next')}</button>
    </>
  )}
</div>

      </div>
    </>
  );
};

export default FamilyBuildingSurrogacyAgency;
